var _circle, _circle2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 25.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 27,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5047 20.3561C15.1695 19.7757 15.2598 19.0434 15.7259 18.5617V18.5617C18.5198 15.674 22.0665 13.6263 25.9644 12.6505V12.6505C26.6146 12.4877 27.2939 12.7757 27.629 13.3561L28.1726 14.2977C28.6187 15.0704 28.2013 16.0553 27.3357 16.2719V16.2719C23.8488 17.1449 20.6759 18.9767 18.1765 21.5601V21.5601C17.5561 22.2013 16.4944 22.0704 16.0483 21.2977L15.5047 20.3561Z",
    fill: "#F4AFC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3723 42.6435C28.7074 43.224 29.3867 43.5119 30.0369 43.3492V43.3492C33.9348 42.3734 37.4815 40.3257 40.2755 37.4379V37.4379C40.7415 36.9563 40.8318 36.224 40.4967 35.6435L39.953 34.7019C39.5069 33.9292 38.4453 33.7984 37.8248 34.4396V34.4396C35.3254 37.0229 32.1525 38.8548 28.6656 39.7277V39.7277C27.8001 39.9444 27.3826 40.9292 27.8287 41.7019L28.3723 42.6435Z",
    fill: "#D4E796"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3563 40.4961C19.7758 40.8312 19.0435 40.7409 18.5618 40.2749V40.2749C15.6741 37.4809 13.6264 33.9342 12.6506 30.0364V30.0364C12.4878 29.3862 12.7758 28.7069 13.3563 28.3717L14.2978 27.8281C15.0705 27.382 16.0554 27.7995 16.2721 28.665V28.665C17.145 32.152 18.9769 35.3248 21.5602 37.8243V37.8243C22.2014 38.4447 22.0705 39.5063 21.2978 39.9525L20.3563 40.4961Z",
    fill: "#8CD2EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6437 27.6284C43.2242 27.2933 43.5122 26.614 43.3494 25.9638V25.9638C42.3736 22.066 40.3259 18.5192 37.4382 15.7253V15.7253C36.9565 15.2592 36.2242 15.169 35.6437 15.5041L34.7022 16.0477C33.9295 16.4938 33.7986 17.5555 34.4398 18.1759V18.1759C37.0231 20.6753 38.855 23.8482 39.7279 27.3352V27.3352C39.9446 28.2007 40.9295 28.6182 41.7022 28.1721L42.6437 27.6284Z",
    fill: "#FFD297"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.1ab78565d6ad1471eea666e77bdd2cb8.svg";
export { ForwardRef as ReactComponent };